import React from 'react';
import { useRef, useState, useEffect } from 'react';
import Game from "../Game/game";
import '../../style.css';

var fs = null, path = null, configPath = '', dataPath = '', onLeaderBoard, timerInt = null;
const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
const scoreMultiplier = {
    'BEGINNER': 10,
    'EXPERT': 20
};

const App = () => {
    const [easyLB, setEasyLB] = useState([]);
    const [complexLB, setComplexLB] = useState([]);
    const [stayingOnLeaderboard, setStayOnLeaderboard] = useState(20);
    const [clickDelay, setClickDelay] = useState(0.5);
    const [gameMode, setGameMode] = useState('');
    const [gameTime, setGameTime] = useState({'BEGINNER': 120.0, 'EXPERT': 90.0});
    const [timer, setTimer] = useState(120.0);
    const [gameState, setGameState] = useState('mode');
    const [fieldHighlight, setFieldHighlight] = useState('name');
    const [keyboardState, setKeyboardState] = useState('');
    const [playerName, setPlayerName] = useState('');
    const [email, setEmail] = useState('');
    const [playerScore, setPlayerScore] = useState(0);
    const [playerPosition, setPlayerPosition] = useState(0);
    const playerNameRef = useRef(null);
    const emailRef = useRef(null);
    const countdownRef = useRef(null);
    const aContextRef = useRef(null);
    const sfx = useRef({});

	const phoneCheck = () => {
		var userAgent = navigator.userAgent || navigator.vendor || window.opera;

		if (userAgent.match(/iPhone/i) || userAgent.match(/iPod/i))
			return true;
		else if (userAgent.match(/Android/i))
			return true;
		else if (userAgent.match(/Mobi/i))
			return true;
		else
			return false;
	}
    const [isPhone, setIsPhone] = useState(phoneCheck());

    const getAudioContext = () => {
        if (!aContextRef.current) {
            aContextRef.current = new AudioContext();
        }
        return aContextRef.current;
    };

    useEffect(() => {
        const isElectron = navigator.userAgent.toLowerCase().includes('electron');
		if (isElectron) {
			const basePath = process.resourcesPath;
			fs = window.require('fs');
			path = window.require('path');
			configPath = path.join(basePath, 'config.json');
			dataPath = path.join(basePath, 'userData.csv');

			const rawConfig = fs.readFileSync(configPath, 'utf8');
			configLoaded(JSON.parse(rawConfig));

		} else {
            fetch('/getConfig')
                .then(response => response.json())
                .then(res => {
                    if(!res.status || res.status != 1) {
                        return console.log(res);
                    }

                    let config = res.data;
                    config.easyLB.sort((a, b) => {
                        return parseInt(b.score) - parseInt(a.score);
                    });

                    config.complexLB.sort((a, b) => {
                        return parseInt(b.score) - parseInt(a.score);
                    });
                    configLoaded(config);
                })
                .catch(e => {
                    console.log(e);
                    configLoaded();
                });
		}
    }, []);

    const loadInSound = (key, url) => {
        const aContext = getAudioContext();
        fetch(url)
            .then(response => response.arrayBuffer())
            .then(arrayBuffer => aContext.decodeAudioData(arrayBuffer))
            .then(audioBuffer => {
                sfx.current[key] = audioBuffer;
            });
    }

    const playSound = audioBuffer => {
        if (!audioBuffer) return;
        const aContext = getAudioContext();
        if (aContext.state === 'suspended') {
            aContext.resume();
        }
        let source = aContext.createBufferSource();
        source.buffer = audioBuffer;
        source.connect(aContext.destination);
        source.start();
    }

    const configLoaded = (config = null) => {
        if(config) {
            setClickDelay(config.clickDelay);
            setGameTime({'BEGINNER': config.beginnerGameTime, 'EXPERT': config.expertGameTime});
            setStayOnLeaderboard(config.leaderboardHold);

            if(config.easyLB) {
                setEasyLB(config.easyLB);
            }
            if(config.complexLB) {
                setComplexLB(config.complexLB);
            }
        }

        let sounds = {
        "beginGame": "./assets/sfx/Begin_Game.wav",
        "cardReset": "./assets/sfx/Card_Reset.wav",
        "cardFlip": "./assets/sfx/Card_Select_Flip.wav",
        "clockTick": "./assets/sfx/Clock_Tick.wav",
        "countOne": "./assets/sfx/Countdown_Number_1.wav",
        "countTwo": "./assets/sfx/Countdown_Number_2.wav",
        "countThree": "./assets/sfx/Countdown_Number_3.wav",
        "gameOver": "./assets/sfx/Game_Over_Leaderboard.wav",
        "noMatch": "./assets/sfx/Match_NO.wav",
        "match": "./assets/sfx/Match_YES.wav",
        "click": "./assets/sfx/Mouse_Click.wav",      
        "ready": "./assets/sfx/Ready.wav",
        "select": "./assets/sfx/Select_Game.wav",       
        }
        for(let key in sounds) {
            loadInSound(key, sounds[key]);
        }
    }

    useEffect(() => {
        if(timerInt) {
        clearInterval(timerInt);
        timerInt = null;
        }

        switch(gameState) {
            case 'mode':
                playerNameRef.current.value = '';
                emailRef.current.value = '';
                setPlayerName('');
                setEmail('');
                setGameMode('');
                if(onLeaderBoard) {
                    clearTimeout(onLeaderBoard);
                    onLeaderBoard = null;
                }
                break;
            case 'home':
                setPlayerScore(0);
                playerNameRef.current.focus();
                setFieldHighlight('name');
                setTimer(gameTime[gameMode]);
                if(playerName.length == 0) setKeyboardState('shift');
                break;
            case 'start':
                countdownRef.current.play();
                break;
            case 'gaming':
                playSound(sfx.current["beginGame"])
                timerInt = setInterval(() => {
                setTimer(prevTimer => prevTimer - .1);
                }, 100);
                break;
            case 'gameOver':
                updateLeaderboard();
                break;
        }
    }, [gameState]);

    useEffect(() => {
        if(timer <= 0) {
            setGameState('gameOver');
            playSound(sfx.current["gameOver"])
        }
    }, [timer]);

    const addScore = msg => {
        setPlayerScore(prevScore => parseInt(prevScore + (timer * scoreMultiplier[gameMode])));
        if(msg == 'end') {
            setTimeout(() => {
                setGameState('gameOver');
            }, 2000);
        }
    }

    const updateLeaderboard = () => {
        let newLB = gameMode == 'BEGINNER' ? easyLB : complexLB, newPosition = 0;

        for(let position = 0; position < newLB.length; position++) {
            newPosition = position + 1;
            if(playerScore > newLB[position]?.score || 0) {
                newLB.splice(position, 0, {name: playerName, score: playerScore});
                break;
            }
        }

        if(newPosition == newLB.length) {
            newLB.push({name: playerName, score: playerScore});
            newPosition++;
        }
        setPlayerPosition(newPosition - 1);

        if(gameMode == 'BEGINNER') {
            setEasyLB([...newLB]);
        }
        else {
            setComplexLB([...newLB]);
        }

        if(fs && path) {
            let d2 = new Date();
            let date = months[d2.getMonth()] + ' ' + d2.getDate();
            let meridian = 'am';
            let hour = d2.getHours();
            if(hour > 12) {
                hour -= 12;
                meridian = 'pm';
            }
            if(hour == 0) hour = 12;
            let minutes = (d2.getMinutes() < 10 ? '0' : '') + d2.getMinutes();
            let time = hour + ':' + minutes + meridian;
            fs.appendFileSync(dataPath, `${date},${time},${gameMode},${playerScore},${playerName},${email}\n`, 'utf8');
        }
        else {
            let params = {
                mode: gameMode == 'BEGINNER' ? 'easy' : 'complex',
                name: playerName,
                score: playerScore,
                email: email
            };

            let options = {
                method: 'POST',
                headers: {'content-type': 'application/json;charset=utf-8'},
                body: JSON.stringify(params)
            }

            fetch(`/recordUser`, options)
            .then(response => response.json())
            .then(res => {
                if(!res.status || res.status != 1) {
                    console.log(res.data);
                    alert("Sorry, we could not record your score.");
                    return;
                }
            })
            .catch(e => {
                alert("Sorry, we could not record your score.");
            });
        }

        onLeaderBoard = setTimeout(() => {
            setGameState('mode');
            onLeaderBoard = null;
        }, stayingOnLeaderboard * 1000);
    }

    const keyPress = key => {
        if(!key) return;

        if(key == 'caps' || key == 'shift') {
            return setKeyboardState(keyboardState == key ? '' : key);
        }

        if(fieldHighlight == 'name') {
            if(key == 'back') {
                if(playerNameRef.current.value.length > 0)
                    playerNameRef.current.value = playerNameRef.current.value.slice(0, -1);
            }
            else if(playerNameRef.current.value.length < 15) {
                if(key == 'space') {
                    playerNameRef.current.value += ' ';
                }
                else {
                    playerNameRef.current.value += key;
                }
                if(keyboardState == 'shift') {
                    setKeyboardState('');
                }
            }
        }
        else {
            if(key == 'back') {
                if(emailRef.current.value.length > 0)
                    emailRef.current.value = emailRef.current.value.slice(0, -1);
            }
            else if(emailRef.current.value.length < 100) {
                if(key != 'space') {
                    emailRef.current.value += key;
                }
                if(keyboardState == 'shift') {
                    setKeyboardState('');
                }
            }
        }
    }

    const backClick = () => {
        setGameState('mode');
    }

    const confirmGameStart = () => {
        setPlayerName(playerNameRef.current.value);
        setEmail(emailRef.current.value);

        if(playerNameRef.current.value.length == 0) {
            return alert('please enter your name');
        }
        else if(emailRef.current.value.length == 0) {
            return alert('please enter an email address');
        }

        setGameState('start');
    }

    return ( 
        <>
            {isPhone && <div id="landscape_notice">
                <p>This website is not optimized for smartphones. Please use a desktop, laptop, or tablet to visit it.</p>
            </div>}
            <div className={"container " + (isPhone ? 'hide' : gameState)}>
                <div id="sideBg"></div> 
                <img id="title" src="./assets/title.png" />
                <section id="sidebar">
                    <div className="mode">{gameMode} MODE</div>
                    <div className="gameDetails">
                        <div className="scoreLabel">SCORE</div>
                        <div className="score">{playerScore.toLocaleString('en-US')}</div>
                        <div className="timerLabel">TIME</div>
                        <div className="timer"><div className="left1">{(Math.floor(timer / 60) < 10 ? '0' : Math.floor(timer / 60).toString()[0])}</div><div className="left2">{Math.floor(timer / 60) < 10 ? Math.floor(timer / 60) : Math.floor(timer / 60).toString()[1]}</div><div className="space"></div><div className="right1">{(Math.floor(timer % 60) < 10 ? '0' : Math.floor(timer % 60).toString()[0])}</div><div className="right2">{Math.floor(timer % 60) < 10 ? Math.floor(timer % 60) : Math.floor(timer % 60).toString()[1]}</div></div>
                        <div className="name"><img src="./assets/chevron-shape.png" /> {playerName}</div>
                    </div>
                    <img id="sideBack" onClick={e => backClick()} src="./assets/button-back.png" />
                </section>
                <main>
                    <img id="contentBox" src="./assets/content-box.png" />
                    <div id="modePage">
                        <img className="topTitle" src="./assets/mode_title.png" />
                        <div className="easyBox">
                            <div className="modeTitle">BEGINNER MODE</div>
                            <div className="modeSubTitle">FIND THE IDENTICAL ICONS!</div>
                            <img onClick={e => {setGameMode('BEGINNER'); setGameState('home'); playSound(sfx.current["select"])}} src="./assets/cards-beginner.png" />
                            <button onClick={e => {setGameMode('BEGINNER'); setGameState('home'); playSound(sfx.current["select"])}}>BEGINNER</button>
                        </div>
                        <div className="complexBox">
                            <div className="modeTitle">EXPERT MODE</div>
                            <div className="modeSubTitle">ARE YOU UP FOR THE CHALLENGE?</div>
                            <img onClick={e => {setGameMode('EXPERT'); setGameState('home'); playSound(sfx.current["select"])}} src="./assets/cards-expert.png" />
                            <button onClick={e => {setGameMode('EXPERT'); setGameState('home'); playSound(sfx.current["select"])}}>EXPERT</button>
                        </div>
                    </div>
                    <div id="homePage">
                        <img className="topTitle" src="./assets/user_title.png" />
                        <div id="userContainer">
                            <div className="nameRow">
                                <div className="playerLabel">NAME<div className="maxName">15 letters maximum</div></div>
                                <input ref={playerNameRef} id="playerName" maxLength="15" onClick={e => setFieldHighlight('name')} onFocus={e => setFieldHighlight('name')} className={fieldHighlight == 'name' ? 'highlight' : ''} />
                            </div>
                            <div className="emailRow">
                                <div className="playerLabel">EMAIL</div>
                                <input ref={emailRef} id="playerEmail" maxLength="100" onClick={e => setFieldHighlight('email')} onFocus={e => setFieldHighlight('email')} className={fieldHighlight == 'email' ? 'highlight' : ''} />
                            </div>
                            <div className="consentRow">
                                <p>By opting in you are indicating that you’d like to stay up to date with all the exciting promotions and new product developments from Eukanuba and Mars Petcare and its affiliates and that you have read and accept the MARS Site – Terms and Conditions and MARS Privacy Policy. From time to time, we may also use your data for research to enhance our product and service offerings to our consumers. Must be 16 years or older to subscribe.<br />I understand that I may change these preferences at any time by contacting Eukanuba at 1-800-423-6036.<br />For more information about how we use your data, please see Mars Privacy Statement.</p>
                            </div>
                            <div className="keyboardContainer" onClick={e => keyPress(e.target.dataset?.key)}>
                                <div className="row">
                                    {(keyboardState == '' ? '~!@#$%^&*()_+' : '`1234567890-=').split('').map(letter => 
                                        (<div key={'kBoard' + letter} data-key={letter} className="key">{letter}</div>)
                                    )}
                                    <div data-key="back" className="key back"><img data-key="back" src="./assets/back_key.png" /></div>
                                </div>
                                <div className="row">
                                    {(keyboardState == '' ? 'qwertyuiop[]\\' : 'QWERTYUIOP{}|').split('').map(letter => 
                                        (<div key={'kBoard' + letter} data-key={letter} className="key">{letter}</div>)
                                    )}
                                </div>
                                <div className="row">
                                    <div data-key="caps" className="key long">Caps</div>
                                    {(keyboardState == '' ? 'asdfghjkl;\'' : 'ASDFGHJKL:"').split('').map(letter => 
                                        (<div key={'kBoard' + letter} data-key={letter} className="key">{letter}</div>)
                                    )}
                                </div>
                                <div className="row">
                                    <div data-key="shift" className="key long">Shift</div>
                                    {(keyboardState == '' ? 'zxcvbnm,./' : 'ZXCVBNM<>?').split('').map(letter => 
                                        (<div key={'kBoard' + letter} data-key={letter} className="key">{letter}</div>)
                                    )}
                                </div>
                            </div>
                            <button onClick={e => {confirmGameStart()}}>START GAME</button>
                        </div>
                    </div>
                    <div id="readyCover">
                    <video ref={countdownRef} id="readyCountdown" src="./assets/Countdown_v02.webm" />
                    </div>
                    <Game gameState={gameState} mode={gameMode} updateGameState={newState => setGameState(newState)} addScore={addScore} clickDelay={clickDelay} playSound={playSound} sfx={sfx.current}/>
                    <div id="leaderboard">
                        <img className="topTitle" src="./assets/leaderboard_title.png" />
                        <div className="modeTitle">{gameMode} MODE</div>
                        <div className="lbContainer">
                            <div className="leftSide">
                                <div className="lbHeader"><div className="position">Position</div><div className="name">Name</div><div className="score">Score</div></div>
                                {[0, 1, 2, 3, 4].map(i => {
                                    let player = (gameMode == 'BEGINNER' ? easyLB[i] : complexLB[i]) || {name: '', score: ''};
                                    return (
                                        <div key={'lbrow' + i} className="row"><div className="position"><div className="num" data-p={i}>{parseInt(i) + 1}</div></div><div className="name">{player.name}</div><div className="score">{player.score.toLocaleString('en-US')}</div></div>
                                    );
                                })}
                            </div>
                            <div className="rightSide">
                                <div className="lbHeader"><div className="position">Position</div><div className="name">Name</div><div className="score">Score</div></div>
                                {[5, 6, 7, 8, 9].map(i => {
                                    let player = (gameMode == 'BEGINNER' ? easyLB[i] : complexLB[i]) || {name: '', score: ''};
                                    return (
                                        <div key={'lbrow' + i} className="row"><div className="position"><div className="num" data-p={i}>{parseInt(i) + 1}</div></div><div className="name">{player.name}</div><div className="score">{player.score.toLocaleString('en-US')}</div></div>
                                    );
                                })}
                            </div>
                        </div>
                        <div className="modeTitle player">YOU</div>
                        <div id="playerPosition">
                            <div className="lbHeader"><div className="position">Position</div><div className="name">Name</div><div className="score">Score</div></div>                    
                            <div className="row"><div className="position"><div className="num" data-p={playerPosition}>{parseInt(playerPosition) + 1}</div></div><div className="name">{playerName}</div><div className="score">{playerScore.toLocaleString('en-US')}</div></div>
                        </div>
                        <button id="restartButton" onClick={e => setGameState('mode')}>RESTART GAME</button>
                    </div>
                </main>
            </div>
        </>
    ) 
}

export default App;